<svg
	xmlns="http://www.w3.org/2000/svg"
	xmlns:xlink="http://www.w3.org/1999/xlink"
	style="margin: auto; background: none; display: block; shape-rendering: auto"
	[attr.width]="size"
	[attr.height]="size"
	viewBox="0 0 100 100"
	preserveAspectRatio="xMidYMid">
	<circle
		cx="50"
		cy="50"
		r="28"
		stroke-width="5"
		stroke="#85a2b6"
		stroke-dasharray="43.982297150257104 43.982297150257104"
		fill="none"
		stroke-linecap="round">
		<animateTransform
			attributeName="transform"
			type="rotate"
			repeatCount="indefinite"
			dur="1.2987012987012987s"
			keyTimes="0;1"
			values="0 50 50;360 50 50" />
	</circle>
</svg>
